import React, { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import './MarketingInfo.css';
import './layout/header.css';
import './menu/BaseImageMenu.css';
import './menu/BaseReviewMenu.css';
import './menu/BaseVideoMenu.css';
import apiClient from '../utils/apiClient';
import Popup from './common/CommonPopup';
import BaseImageMenu from './menu/BaseImageMenu';
import BaseReviewMenu from './menu/BaseReviewMenu';
import BaseVideoMenu from './menu/BaseVideoMenu';
import MenuHeader from './layout/header';
import MenuFooter from './layout/footer';
import History from './History';
import parse from "html-react-parser"; // npm i html-react-parser
import camelCase from 'lodash/camelCase';

const MarketingInfo = () => {
  const { uid: idx } = useParams();
  const [isValidIdx, setIsValidIdx] = useState(null);
  const [loading, setLoading] = useState(true);
  const [marketingData, setMarketingData] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedSection, setSelectedSection] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [contentTypeData, setContentTypeData] = useState([]);

  const [menuTitle, setMenuTitle] = useState('');
  const [viewMenuType, setViewMenuType] = useState('');
  const [sectionItem, setSectionItem] = useState([]);

  const [cssLoaded, setCssLoaded] = useState(false);
  const [menuItems, setMenuItems] = useState([]);

  const [noticeText, setNoticeText] = useState('*자세한상담은 계약 초기생성된 단톡방으로 문의부탁드립니다.');
  const logoUrl = '/images/logo.png';
  const [expanded, setExpanded] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const [videoUrl, setVideoUrl] = useState('');
  const [reelsVideoUrl, setReelsVideoUrl] = useState('');
  const [viewImageUrl, setViewImageUrl] = useState('');
  
  // 패스워드 관련 상태
  const [isPasswordRequired, setIsPasswordRequired] = useState(false);
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [invalidAccess, setInvalidAccess] = useState(false);
  
  // 히스토리 관련 상태
  const [showHistory, setShowHistory] = useState(false);

  // 히스토리 클릭 핸들러
  const handleNotificationClick = () => {
    setShowHistory(true);
  };

  const handleCloseHistory = () => {
    setShowHistory(false);
  };
  const handleGoMenu = (menuId) => {
    setShowHistory(false);
    handleMenuClick(menuId);
  };

  // 동적 CSS 임포트 with 로딩 상태 관리
  useEffect(() => {
    if (!selectedSection) return;
    
    setCssLoaded(false); // CSS 로딩 시작
    
    let importPromise;
    
    if (selectedSection === 'homepage') {
      importPromise = import('./MarketingInfoHomepage.css');
    } else if (selectedSection === 'place-ranking') {
      importPromise = import('./MarketingInfoPlaceRanking.css');
    }
    //  else if (selectedSection === 'knowledge-viral') {
    //   importPromise = import('./MarketingInfoKnowledge.css');
    // } else if (selectedSection === 'mom-cafe') {
    //   importPromise = import('./MarketingInfoMomCafe.css');
    // } else if (selectedSection === 'blog') {
    //   importPromise = import('./MarketingInfoBlog.css');
    // } else if (selectedSection === 'blog-review') {
    //   importPromise = import('./MarketingInfoBlogReview.css');
    // } else if (selectedSection === 'instagram') {
    //   importPromise = import('./MarketingInfoInstagram.css');
    // } else if (selectedSection === 'reels') {
    //   importPromise = import('./MarketingInfoReels.css');
    // } else if (selectedSection === 'video') {
    //   importPromise = import('./MarketingInfoVideo.css');
    // }
    
    if (importPromise) {
      importPromise.then(() => {
        // CSS 로딩이 완료된 후 약간의 지연을 주어 브라우저가 스타일을 완전히 적용하도록 함
        setTimeout(() => {
          setCssLoaded(true);
        }, 50);
      }).catch(() => {
        setCssLoaded(true); // 에러가 발생해도 렌더링은 진행
      });
    } else {
      setCssLoaded(true);
    }
  }, [selectedSection]);

  // 패스워드 제출 함수
  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    
    if (!password.trim()) {
      setPasswordError('패스워드를 입력해주세요.');
      return;
    }
    
    setIsSubmitting(true);
    setPasswordError('');
    
    try {
      const response = await apiClient.get('/Customer/GetMarketingData', {
        idx: idx,
        password: password.trim()
      });
      
      if (response && response.success && response.data) {
        let baseGetDummyData = getDummyData();
        let menuItems = getMenuItems();
        baseGetDummyData.companyName = response.data.companyName;
        baseGetDummyData.period = response.data.period;
        baseGetDummyData.placeRank = response.data.placeRank;
        baseGetDummyData.blogReview = response.data.typeData.blogReview;
        baseGetDummyData.momCafe = response.data.typeData.momCafe;
        baseGetDummyData.blog = response.data.typeData.blog;
        baseGetDummyData.promotionVideo = response.data.typeData.promotionVideo;
        baseGetDummyData.reelsVideo = response.data.typeData.reelsVideo;
        baseGetDummyData.knowledge = response.data.typeData.knowledge;
        baseGetDummyData.instagram = response.data.instagram;
        baseGetDummyData.typeData = response.data.typeData;
        baseGetDummyData.data = response.data.data;
        // if (response.data.placeRank.rankList?.length > 0) {
        //   menuItems.find(item => item.id === 'place-rank').isVisible = true;
        // }
        // if (response.data.blogReview?.length > 0) {
        //   menuItems.find(item => item.id === 'blog-review').isVisible = true;
        // }
        // if (response.data.momCafe?.length > 0) {
        //   menuItems.find(item => item.id === 'momCafe').isVisible = true;
        // }
        // if (response.data.blog?.length > 0) {
        //   menuItems.find(item => item.id === 'blog').isVisible = true;
        // }
        // if (response.data.promotionVideo?.length > 0) {
        //   menuItems.find(item => item.id === 'promotion-video').isVisible = true;
        // }
        // if (response.data.reelsVideo?.length > 0) {
        //   menuItems.find(item => item.id === 'reels-video').isVisible = true;
        // }
        // if (response.data.knowledge?.length > 0) {
        //   menuItems.find(item => item.id === 'knowledge').isVisible = true;
        // }
        // if (response.data.instagram?.length > 0) {
        //   menuItems.find(item => item.id === 'instagram').isVisible = true;
        // }

        setContentTypeData(response.data.contentTypeData);
        setNoticeText(response.data.notice);
        menuItems = response.data.viewMenu.map(item => ({
          id: item.id,
          isVisible: item.isVisible === 'Y',
          icon: parse(item.icon),
          label: item.label,
          description: item.description,
          hasArrow: item.hasArrow
        }));
        setMarketingData(baseGetDummyData);
        setMenuItems(menuItems);
        setIsPasswordRequired(false);
        setLoading(false);
      } else {
        setPasswordError(response?.message || '패스워드가 올바르지 않습니다.');
      }
    } catch (error) {
      console.error('❌ 마케팅 데이터 로드 실패:', error);
      setPasswordError('데이터를 불러오는 데 실패했습니다. 다시 시도해주세요.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handelSetViewMenu = async (menuType, targetIdx) => {

    try {
      const response = await apiClient.post('/Customer/SetViewMenu', {
        customerIdx: idx,
        type : menuType,
        targetIdx : targetIdx
      });
      
    } catch (error) {

    }
  };

  useEffect(() => {
    // idx 유효성 검증
    const validateIdx = () => {
      // idx가 존재하고 비어있지 않은 문자열인지 확인
      if (!idx || idx.trim() === '') {
        setIsValidIdx(false);
        setLoading(false);
        return;
      }

      // idx가 숫자로만 이루어져 있는지 검증
      const idxPattern = /^\d+$/; // 숫자만 허용
      if (!idxPattern.test(idx)) {
        setInvalidAccess(true);
        setLoading(false);
        return;
      }

      setIsValidIdx(true);
      setIsPasswordRequired(true);
      setLoading(false);
    };

    validateIdx();
  }, [idx]);

  // 더미 데이터 (패스워드 인증 후 사용할 예정)
  const getDummyData = () => {
    return {
          uid: idx,
          totalScore: '1,530점',
          gradeDisplay: '상위 35%',
          period: '2025.06.09~2025.08.09',
          detailStats: {
            homePageVisits: '320점',
            companyIntro: '280점',
            showroomVisits: '450점',
            brochureDownloads: '480점'
          },
          homepageData: {
            score: '320점',
            maxScore: '100점 만점 기준 64점',
            pageLoadSpeed: 67,
            mobileOptimization: 83,
            seoScore: 58,
            monthlyVisitors: { value: '2,847', change: '+12.5%' },
            avgStayTime: { value: '2분 34초', change: '+8.3%' },
            pageViews: { value: '12,482', change: '+15.2%' },
            bounceRate: { value: '45.2%', change: '-3.1%' },
            improvements: [
              { text: '이미지 최적화 필요', status: 'warning', desc: '대용량 이미지 4개가 로딩 속도를 저하시키고 있습니다' },
              { text: '메타 태그 추가', status: 'warning', desc: '검색엔진 최적화를 위해 description 메타태그가 필요합니다' },
              { text: 'SSL 인증서 적용 완료', status: 'success', desc: '보안 연결이 정상으로 설정되어 있습니다' }
            ]
          },
          placeRankingData: {
            currentRank: 3,
            rankChange: '+2',
            period: '지난주 대비',
            searchKeywords: ['강남 헤어샵', '강남역 미용실'],
            monthlyExposure: { value: '15,424', change: '전월 대비 +23%' },
            clickCount: { value: '1,847', rate: '클릭률 12.0%' },
            keywordRankings: [
              { keyword: '강남 헤어샵', rank: 3, trend: 'up', change: '+2' },
              { keyword: '강남역 미용실', rank: 5, trend: 'up', change: '+1' },
              { keyword: '헤어 컷팅', rank: 8, trend: 'down', change: '-1' },
              { keyword: '파마 전문', rank: 12, trend: 'up', change: '+5' },
              { keyword: '염색 맛집', rank: 15, trend: 'same', change: '0' }
            ],
            reviewStats: {
              averageScore: 4.8,
              totalReviews: 247,
              distribution: [
                { star: 5, count: 189 },
                { star: 4, count: 43 },
                { star: 3, count: 12 },
                { star: 2, count: 2 },
                { star: 1, count: 1 }
              ]
            }
          },
          knowledgeViralData: {
            registeredAnswers: 24,
            adoptedAnswers: 18,
            adoptionRate: 75,
            industryAverage: 45,
            totalViews: { value: '48,392', description: '이번달 누적' },
            helpfulVotes: { value: '1,247', description: '평균 26개/답변' },
            recentAnswers: [
              { 
                question: '강남에서 파마 잘하는 곳 추천해주세요', 
                views: 1247, 
                likes: 23, 
                period: '2일 전',
                status: 'adopted',
                statusText: '채택됨'
              },
              { 
                question: '헤어샵 예약 어떻게 하나요?', 
                views: 858, 
                likes: 18, 
                period: '1일 전',
                status: 'waiting',
                statusText: '대기중'
              },
              { 
                question: '염색 후 관리법 알려주세요', 
                views: 2134, 
                likes: 41, 
                period: '3일 전',
                status: 'adopted',
                statusText: '채택됨'
              }
            ],
            keywordPerformance: [
              { keyword: '강남 파마', score: 92, status: 'up', statusText: '상승' },
              { keyword: '헤어샵 추천', score: 87, status: 'up', statusText: '상승' },
              { keyword: '염색 전문', score: 76, status: 'same', statusText: '유지' },
              { keyword: '헤어 트리트먼트', score: 68, status: 'down', statusText: '하락' }
            ]
          },
          momCafeData: {
            recommendedPosts: 12,
            registeredPosts: 28,
            totalParticipants: '4.2K',
            achievement: '이번 주 하이라이트: 강남점 이벤트 게시글 1.2K 좋아요 달성',
            totalLikes: { value: '2,847', description: '이번달 누적' },
            totalComments: { value: '892', description: '평균 32개/게시글' },
            popularPosts: [
              {
                title: '강남 헤어샵 후기 - 파마 대박 잘됐어요!',
                source: '강남맘카페',
                likes: 156,
                comments: 23,
                views: 8,
                status: 'processing',
                statusText: '진행중'
              },
              {
                title: '아이 헤어컷 어디서 하세요? 추천부탁드려요',
                source: '서초맘들',
                likes: 89,
                comments: 34,
                views: 5,
                status: 'completed',
                statusText: '완료'
              },
              {
                title: '헤어 트리트먼트 효과 진짜 좋네요',
                source: '역삼동맘카페',
                likes: 67,
                comments: 12,
                views: 3,
                status: 'processing',
                statusText: '진행중'
              }
            ],
            cafeRanking: [
              { rank: 1, name: '강남맘카페', description: '회원 12.4K명', percentage: 94, desc: '8개 게시글' },
              { rank: 2, name: '서초맘들', description: '회원 8.9K명', percentage: 87, desc: '6개 게시글' },
              { rank: 3, name: '역삼동맘카페', description: '회원 5.2K명', percentage: 79, desc: '5개 게시글' },
              { rank: 4, name: '신사동엄마들', description: '회원 3.8K명', percentage: 72, desc: '4개 게시글' },
              { rank: 5, name: '압구정맘들모여', description: '회원 2.1K명', percentage: 68, desc: '5개 게시글' }
            ]
          },
          blogData: {
            topRankings: 15,
            averageRank: 3.2,
            goalAchievement: 89,
            achievement: "이번 주 성과: '강남 헤어샵' 키워드 1페이지 진입 달성",
            monthlyExposure: { value: '125K', description: '전월 대비 +18%' },
            clickRate: { value: '12.5%', description: '업계 평균 8.2%' },
            keywordRankings: [
              {
                keyword: '강남 헤어샵 추천',
                url: 'blog.naver.com/hairshop123',
                rank: 2,
                change: 2,
                direction: 'up'
              },
              {
                keyword: '파마 전문 미용실',
                url: 'blog.naver.com/hairshop123',
                rank: 1,
                change: 2,
                direction: 'up'
              },
              {
                keyword: '강남역 염색 맛집',
                url: 'tistory.com/haircare',
                rank: 3,
                change: 1,
                direction: 'down'
              },
              {
                keyword: '헤어 트리트먼트 후기',
                url: 'blog.naver.com/hairshop123',
                rank: 5,
                change: 2,
                direction: 'up'
              },
              {
                keyword: '남자 헤어컷 스타일',
                url: 'tistory.com/haircare',
                rank: 8,
                change: 4,
                direction: 'up'
              }
            ]
          },
          blogReviewData: {
            publishedReviews: 18,
            averageRating: 4.6,
            totalViews: '2.8K',
            achievement: "이번 주 하이라이트: 파마 제품 리뷰가 500+ 조회수 달성",
            avgRatingDetail: { value: '4.6/5', description: '18개 리뷰 기준' },
            avgViews: { value: '1,444', description: '리뷰당 평균' },
            recentReviews: [
              {
                title: '강남 헤어샵에서 받은 파마 제품기',
                source: '뷰티인사이더',
                rating: 5,
                views: 1284,
                likes: 23,
                timeAgo: '2일 전',
                status: 'processing'
              },
              {
                title: '염색 후 헤어제품 제품 솔직후기',
                source: '헤어스토리',
                rating: 4,
                views: 892,
                likes: 15,
                timeAgo: '4일 전',
                status: 'completed'
              },
              {
                title: '트리트먼트 효과 한달 사용 후기',
                source: '라이프스타일',
                rating: 5,
                views: 2156,
                likes: 34,
                timeAgo: '1주 전',
                status: 'completed'
              }
            ]
          },
          instagramData: {
            publishedPosts: 24,
            totalViews: '156K',
            engagementRate: '8.2%',
            achievement: "이번 주 성과: 파마 변신 릴스가 25K 재생수 돌파",
            avgViews: { value: '6.5K', description: '릴스당 평균' },
            likeRate: { value: '7.8%', description: '업계 평균 5.2%' },
            popularReels: [
              {
                title: '파마 전후 변신 타임랩스',
                views: '25.4K',
                likes: 1847,
                comments: 156,
                engagementRate: '12.5%'
              },
              {
                title: '헤어 스타일링 꿀팁 모음',
                views: '18.2K',
                likes: 1234,
                comments: 89,
                engagementRate: '9.8%'
              },
              {
                title: '염색 과정 ASMR 영상',
                views: '32.1K',
                likes: 2156,
                comments: 245,
                engagementRate: '15.3%'
              }
            ],
            hashtagPerformance: [
              { hashtag: '#강남헤어샵', engagementRate: '8.5%', reach: '12.4K' },
              { hashtag: '#파마추천', engagementRate: '12.3%', reach: '8.9K' },
              { hashtag: '#헤어스타일링', engagementRate: '9.0%', reach: '16.2K' },
              { hashtag: '#염색전문', engagementRate: '9.7%', reach: '7.3K' }
            ]
          },
          videoData: {
            completedVideos: 8,
            totalViews: '89.2K',
            avgWatchTime: '4.5분',
            achievement: "이번 주 하이라이트: 매장 소개 영상이 15K 재생수 달성",
            avgEngagement: { value: '75.8%', description: '업계 평균 45%' },
            subscriptionRate: { value: '2.1%', description: '총 123명 구독' },
            videoList: [
              {
                title: '강남 프리미엄 헤어샵 매장 소개',
                platform: 'YouTube',
                duration: '2:34',
                views: '15.2K',
                likes: 45,
                engagementRate: '78%',
                status: 'active',
                statusText: '활성'
              },
              {
                title: '파마 시술 과정 타임랩스',
                platform: 'Instagram',
                duration: '1:28',
                views: '12.8K',
                likes: 32,
                engagementRate: '65%',
                status: 'active',
                statusText: '활성'
              },
              {
                title: '헤어 디자이너 인터뷰',
                platform: 'YouTube',
                duration: '3:45',
                views: '8.4K',
                likes: 18,
                engagementRate: '58%',
                status: 'parse',
                statusText: '일시정지'
              },
              {
                title: '고객 만족도 인터뷰',
                platform: 'Facebook',
                duration: '2:12',
                views: '11.3K',
                likes: 28,
                engagementRate: '72%',
                status: 'active',
                statusText: '활성'
              }
            ],
            platformDistribution: [
              { platform: 'YouTube', videoCount: 4, totalViews: '45.2K', percentage: 65 },
              { platform: 'Instagram', videoCount: 2, totalViews: '23.1K', percentage: 28 },
              { platform: 'Facebook', videoCount: 2, totalViews: '20.9K', percentage: 7 }
            ]
          }
        };
  };

  const getMenuItems = () => {
    return menuItem;
  }
  var menuItem = [
    { id : "homepage", isVisible : true, icon: <svg viewBox="0 0 22 22" fill="none" class="w-full h-full"><path d="M2.75 11.9167H19.25M7.33333 19.25H14.6667M9.16667 15.5833L8.70833 19.25M12.8333 15.5833L13.2917 19.25M2.75 3.66667C2.75 3.42355 2.84658 3.19039 3.01849 3.01849C3.19039 2.84658 3.42355 2.75 3.66667 2.75H18.3333C18.5764 2.75 18.8096 2.84658 18.9815 3.01849C19.1534 3.19039 19.25 3.42355 19.25 3.66667V14.6667C19.25 14.9098 19.1534 15.1429 18.9815 15.3148C18.8096 15.4868 18.5764 15.5833 18.3333 15.5833H3.66667C3.42355 15.5833 3.19039 15.4868 3.01849 15.3148C2.84658 15.1429 2.75 14.9098 2.75 14.6667V3.66667Z" stroke="#3EB034" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"></path></svg>, label: '홈페이지', hasArrow: true },
    { id : "place-rank", isVisible : true, icon: <svg viewBox="0 0 22 22" fill="none" class="w-full h-full"><g><path d="M4.58333 11H2.75L11 2.75L19.25 11H17.4167" stroke="#3EB034" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"></path><path d="M4.58333 11V17.4167C4.58333 17.9029 4.77649 18.3692 5.1203 18.713C5.46412 19.0568 5.93044 19.25 6.41667 19.25H15.5833C16.0696 19.25 16.5359 19.0568 16.8797 18.713C17.2235 18.3692 17.4167 17.9029 17.4167 17.4167V11" stroke="#3EB034" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"></path><path d="M9.16667 11H12.8333V14.6667H9.16667V11Z" stroke="#3EB034" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"></path></g></svg>, label: '내 플레이스 순위', hasArrow: true },
    { id : "knowledge", isVisible : true, icon: <svg viewBox="0 0 19 19" fill="none" class="w-full h-full"><g><path d="M9.25 1L17.5 6.4375L9.25 11.875L1 6.4375L9.25 1Z" stroke="#3EB034" strokeLinejoin="round" strokeWidth="1.46667"></path><path d="M9.25 5.3413C8.80817 5.3413 8.45 5.69947 8.45 6.1413C8.45 6.58312 8.80817 6.9413 9.25 6.9413V5.3413ZM9.25 6.1413V6.9413L17.25 6.9413V6.1413V5.3413L9.25 5.3413V6.1413Z" fill="#3EB034"></path><path d="M4.18741 8.56392L9.24991 11.8452V17.2827L4.18741 14.0014V8.56392Z" stroke="#3EB034" strokeLinejoin="round" strokeWidth="1.46667"></path><path d="M14.3126 8.56392L9.25009 11.8452V17.2827L14.3126 14.0014V8.56392Z" stroke="#3EB034" strokeLinejoin="round" strokeWidth="1.46667"></path><path d="M17.5 6.50004L17.5 12" stroke="#3EB034" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.46667"></path></g></svg>, label: '지식인 바이럴', hasArrow: true },
    { id : "momCafe", isVisible : true, icon: <svg viewBox="0 0 19 19" fill="none" class="w-full h-full"><g><path d="M9.25 1L17.5 6.4375L9.25 11.875L1 6.4375L9.25 1Z" stroke="#3EB034" strokeLinejoin="round" strokeWidth="1.46667"></path><path d="M9.25 5.3413C8.80817 5.3413 8.45 5.69947 8.45 6.1413C8.45 6.58312 8.80817 6.9413 9.25 6.9413V5.3413ZM9.25 6.1413V6.9413L17.25 6.9413V6.1413V5.3413L9.25 5.3413V6.1413Z" fill="#3EB034"></path><path d="M4.18741 8.56392L9.24991 11.8452V17.2827L4.18741 14.0014V8.56392Z" stroke="#3EB034" strokeLinejoin="round" strokeWidth="1.46667"></path><path d="M14.3126 8.56392L9.25009 11.8452V17.2827L14.3126 14.0014V8.56392Z" stroke="#3EB034" strokeLinejoin="round" strokeWidth="1.46667"></path><path d="M17.5 6.50004L17.5 12" stroke="#3EB034" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.46667"></path></g></svg>, label: '맘카페 바이럴', hasArrow: true },
    { id : "blog", isVisible : true, icon: <svg viewBox="0 0 22 22" fill="none" class="w-full h-full"><path d="M5.5 19.25V17.4167C5.5 16.4442 5.88631 15.5116 6.57394 14.8239C7.26157 14.1363 8.19421 13.75 9.16667 13.75H12.375M7.33333 6.41667C7.33333 7.38913 7.71964 8.32176 8.40727 9.00939C9.09491 9.69702 10.0275 10.0833 11 10.0833C11.9725 10.0833 12.9051 9.69702 13.5927 9.00939C14.2804 8.32176 14.6667 7.38913 14.6667 6.41667C14.6667 5.44421 14.2804 4.51157 13.5927 3.82394C12.9051 3.13631 11.9725 2.75 11 2.75C10.0275 2.75 9.09491 3.13631 8.40727 3.82394C7.71964 4.51157 7.33333 5.44421 7.33333 6.41667ZM16.885 14.3091C17.0638 14.1304 17.276 13.9886 17.5095 13.8918C17.7431 13.7951 17.9934 13.7453 18.2463 13.7453C18.4991 13.7453 18.7494 13.7951 18.983 13.8918C19.2165 13.9886 19.4287 14.1304 19.6075 14.3091C19.7863 14.4879 19.9281 14.7001 20.0248 14.9337C20.1216 15.1673 20.1713 15.4176 20.1713 15.6704C20.1713 15.9232 20.1216 16.1735 20.0248 16.4071C19.9281 16.6407 19.7863 16.8529 19.6075 17.0316L16.5 20.1666H13.75V17.4166L16.885 14.3091Z" stroke="#3EB034" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"></path></svg>, label: '블로그 상위 노출', hasArrow: true },
    { id : "blog-review", isVisible : true, icon: <svg viewBox="0 0 22 22" fill="none" class="w-full h-full"><path d="M7.33333 8.25H14.6667M7.33333 11.9167H12.8333M16.5 3.66667C17.2293 3.66667 17.9288 3.9564 18.4445 4.47212C18.9603 4.98785 19.25 5.68732 19.25 6.41667V13.75C19.25 14.4793 18.9603 15.1788 18.4445 15.6945C17.9288 16.2103 17.2293 16.5 16.5 16.5H11.9167L7.33333 19.25V16.5H5.5C4.77065 16.5 4.07118 16.2103 3.55546 15.6945C3.03973 15.1788 2.75 14.4793 2.75 13.75V6.41667C2.75 5.68732 3.03973 4.98785 3.55546 4.47212C4.07118 3.9564 4.77065 3.66667 5.5 3.66667H16.5Z" stroke="#3EB034" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"></path></svg>, label: '블로그 리뷰', hasArrow: true },
    { id : "instagram", isVisible : true, icon: <svg viewBox="0 0 22 22" fill="none" class="w-full h-full"><path d="M15.125 6.875V6.88417M3.66667 7.33333C3.66667 6.36087 4.05298 5.42824 4.74061 4.74061C5.42824 4.05298 6.36087 3.66667 7.33333 3.66667H14.6667C15.6391 3.66667 16.5718 4.05298 17.2594 4.74061C17.947 5.42824 18.3333 6.36087 18.3333 7.33333V14.6667C18.3333 15.6391 17.947 16.5718 17.2594 17.2594C16.5718 17.947 15.6391 18.3333 14.6667 18.3333H7.33333C6.36087 18.3333 5.42824 17.947 4.74061 17.2594C4.05298 16.5718 3.66667 15.6391 3.66667 14.6667V7.33333ZM8.25 11C8.25 11.7293 8.53973 12.4288 9.05546 12.9445C9.57118 13.4603 10.2707 13.75 11 13.75C11.7293 13.75 12.4288 13.4603 12.9445 12.9445C13.4603 12.4288 13.75 11.7293 13.75 11C13.75 10.2707 13.4603 9.57118 12.9445 9.05546C12.4288 8.53973 11.7293 8.25 11 8.25C10.2707 8.25 9.57118 8.53973 9.05546 9.05546C8.53973 9.57118 8.25 10.2707 8.25 11Z" stroke="#3EB034" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"></path></svg>, label: '인스타 추천탭 게시글', hasArrow: true },
    { id : "reels-video", isVisible : true, icon: <svg viewBox="0 0 22 22" fill="none" class="w-full h-full"><g><path d="M13.75 9.16666L17.9236 7.08033C18.0633 7.01051 18.2185 6.97755 18.3746 6.98458C18.5306 6.99161 18.6823 7.03839 18.8151 7.12049C18.948 7.20258 19.0577 7.31727 19.1338 7.45366C19.2099 7.59006 19.2499 7.74364 19.25 7.89983V14.1002C19.2499 14.2564 19.2099 14.4099 19.1338 14.5463C19.0577 14.6827 18.948 14.7974 18.8151 14.8795C18.6823 14.9616 18.5306 15.0084 18.3746 15.0154C18.2185 15.0224 18.0633 14.9895 17.9236 14.9197L13.75 12.8333V9.16666Z" stroke="#3EB034" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"></path><path d="M2.75 7.33333C2.75 6.8471 2.94315 6.38079 3.28697 6.03697C3.63079 5.69315 4.0971 5.5 4.58333 5.5H11.9167C12.4029 5.5 12.8692 5.69315 13.213 6.03697C13.5568 6.38079 13.75 6.8471 13.75 7.33333V14.6667C13.75 15.1529 13.5568 15.6192 13.213 15.963C12.8692 16.3068 12.4029 16.5 11.9167 16.5H4.58333C4.0971 16.5 3.63079 16.3068 3.28697 15.963C2.94315 15.6192 2.75 15.1529 2.75 14.6667V7.33333Z" stroke="#3EB034" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"></path></g></svg>, label: '인스타그램 릴스영상', hasArrow: true },
    { id : "promotion-video", isVisible : true, icon: <svg viewBox="0 0 22 22" fill="none" class="w-full h-full"><g><path d="M13.75 9.16666L17.9236 7.08033C18.0633 7.01051 18.2185 6.97755 18.3746 6.98458C18.5306 6.99161 18.6823 7.03839 18.8151 7.12049C18.948 7.20258 19.0577 7.31727 19.1338 7.45366C19.2099 7.59006 19.2499 7.74364 19.25 7.89983V14.1002C19.2499 14.2564 19.2099 14.4099 19.1338 14.5463C19.0577 14.6827 18.948 14.7974 18.8151 14.8795C18.6823 14.9616 18.5306 15.0084 18.3746 15.0154C18.2185 15.0224 18.0633 14.9895 17.9236 14.9197L13.75 12.8333V9.16666Z" stroke="#3EB034" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"></path><path d="M2.75 7.33333C2.75 6.8471 2.94315 6.38079 3.28697 6.03697C3.63079 5.69315 4.0971 5.5 4.58333 5.5H11.9167C12.4029 5.5 12.8692 5.69315 13.213 6.03697C13.5568 6.38079 13.75 6.8471 13.75 7.33333V14.6667C13.75 15.1529 13.5568 15.6192 13.213 15.963C12.8692 16.3068 12.4029 16.5 11.9167 16.5H4.58333C4.0971 16.5 3.63079 16.3068 3.28697 15.963C2.94315 15.6192 2.75 15.1529 2.75 14.6667V7.33333Z" stroke="#3EB034" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"></path></g></svg>, label: '플레이스 홍보영상', hasArrow: true },

  ];
  // 잘못된 접근인 경우 (idx가 숫자가 아님)
  if (invalidAccess) {
    return (
      <div className="marketing-page">
        <div className="marketing-container">
          <div className="error-message">
            <h2>잘못된 접근입니다.</h2>
            <p>올바른 경로로 접근해주세요.</p>
          </div>
        </div>
      </div>
    );
  }

  // idx가 유효하지 않으면 대시보드로 리다이렉트
  if (isValidIdx === false) {
    return <Navigate to="/Admin/dashboard" replace />;
  }

  // 패스워드 입력이 필요한 경우
  if (isPasswordRequired) {
    return (
      <div className="marketing-page">
        <div className="marketing-container">
          <div className="password-form-container">
            <h2>마케팅 정보 접근</h2>
            <p>데이터 열람을 위해 패스워드를 입력해주세요.</p>
            
            <form onSubmit={handlePasswordSubmit} className="password-form">
              <div className="form-group">
                <label htmlFor="password">패스워드</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="패스워드를 입력하세요"
                  disabled={isSubmitting}
                />
                {passwordError && (
                  <div className="error-text">{passwordError}</div>
                )}
              </div>
              
              <button 
                type="submit" 
                className="submit-button"
                disabled={isSubmitting || !password.trim()}
              >
                {isSubmitting ? '확인 중...' : '확인'}
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }

  // 로딩 중일 때 표시
  if (loading) {
    return (
      <div className="marketing-page">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>마케팅 정보를 불러오는 중...</p>
        </div>
      </div>
    );
  }

  // 메뉴 클릭 핸들러
  const handleMenuClick = (menuLabel) => {
    if (menuLabel === 'homepage') {
      // 에이치애드 홈페이지로 이동
      window.open('https://h-ad.kr/', '_blank');
    } else if (menuLabel === 'place-rank') {
      setSelectedSection('place-ranking');
    }else {
      if (contentTypeData.find(item => item.id === menuLabel)) {
        const menuTitle = contentTypeData.find(item => item.id === menuLabel).title;
        
        const externalKey = menuLabel;
        const toCamelCase = str => str.replace(/-([a-z])/g, (_, c) => c.toUpperCase());

        const camelKey = toCamelCase(externalKey);
        if (typeof(marketingData.typeData[camelKey]) === 'undefined' || marketingData.typeData[camelKey].length === 0) {
          alert("등록된 항목이 없습니다.");
          return;
        }

        const menuContentType = marketingData.typeData[camelKey][0].contentType;

        const checkNew = marketingData.typeData[camelKey].some(el => el.isNew === "Y");
        if (checkNew){
          const lastIdx = marketingData.typeData[camelKey].slice(-1)[0].idx;
          const menuType = menuLabel;
          // handelSetViewMenu(menuType, lastIdx);
          // setMarketingData(prev => ({
          //   ...prev,
          //   typeData: {
          //     ...prev.typeData,
          //     [camelKey]: prev.typeData[camelKey].map(el => 
          //       el.isNew === "Y" ? { ...el, isNew: "N" } : el
          //     )
          //   }
          // }));
        }
        setViewMenuType(menuLabel);
        setMenuTitle(menuTitle);
        setSectionItem(marketingData.typeData[camelKey]);
        
        setSelectedSection(menuContentType)
      } else {
        setSelectedSection(menuLabel);
      }
    }
    // } else if (menuLabel === 'knowledge') {
    //   setSelectedSection('knowledge-viral');
    // } else if (menuLabel === 'mom-cafe') {
    //   setSelectedSection('mom-cafe');
    // } else if (menuLabel === 'blog') {
    //   setSelectedSection('blog');
    // } else if (menuLabel === 'blog-review') {
    //   setSelectedSection('blog-review');
    // } else if (menuLabel === 'instagram') {
    //   setSelectedSection('instagram');
    // } else if (menuLabel === 'reels-video') {
    //   setSelectedSection('reels');
    // } else if (menuLabel === 'promotion-video') {
    //   setSelectedSection('video');
    // }
    // 다른 메뉴들도 추후 추가 가능
  };

  const convertNewType = (targetIdx) =>{
    const toCamelCase = str => str.replace(/-([a-z])/g, (_, c) => c.toUpperCase());
    const camelKey = toCamelCase(viewMenuType);

    if (marketingData.typeData[camelKey].find(el => el.idx === targetIdx).isNew === "Y"){
      setMarketingData(prev => ({
        ...prev,
        typeData: {
          ...prev.typeData,
          [camelKey]: prev.typeData[camelKey].map(el => 
            el.idx === targetIdx ? { ...el, isNew: "N" } : el
          )
        }
      }));
  
      handelSetViewMenu(viewMenuType, targetIdx);
    }

    
  };

  const renderHomepageDetail = () => {
    const { homepageData } = marketingData;
    
    return (
      <div className="homepage-detail">
        {/* 헤더 */}
        <div className="detail-header">
          <button className="back-button" onClick={() => setSelectedSection(null)}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="m15 18-6-6 6-6"/>
            </svg>
            홈페이지
          </button>
        </div>

        {/* 홈페이지 최적화 점수 섹션 */}
        <div className="homepage-score-section">
          <div className="homepage-score-header">
            <div className="score-icon">
              <svg viewBox="0 0 22 22" fill="none" className="w-full h-full">
                <path d="M2.75 11.9167H19.25M7.33333 19.25H14.6667M9.16667 15.5833L8.70833 19.25M12.8333 15.5833L13.2917 19.25M2.75 3.66667C2.75 3.42355 2.84658 3.19039 3.01849 3.01849C3.19039 2.84658 3.42355 2.75 3.66667 2.75H18.3333C18.5764 2.75 18.8096 2.84658 18.9815 3.01849C19.1534 3.19039 19.25 3.42355 19.25 3.66667V14.6667C19.25 14.9098 19.1534 15.1429 18.9815 15.3148C18.8096 15.4868 18.5764 15.5833 18.3333 15.5833H3.66667C3.42355 15.5833 3.19039 15.4868 3.01849 15.3148C2.84658 15.1429 2.75 14.9098 2.75 14.6667V3.66667Z" stroke="#3EB034" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.6"/>
              </svg>
            </div>
            <span className="homepage-score-title">홈페이지 최적화 점수</span>
          </div>
          
          <div className="main-homepage-score">
            <span className="homepage-score-number">{homepageData.score}</span>
            <span className="homepage-score-subtitle">{homepageData.maxScore}</span>
          </div>

          {/* 세부 점수 */}
          <div className="score-details">
            <div className="score-detail-item">
              <span className="detail-label">페이지 로딩 속도</span>
              <div className="detail-value-container">
                <div className="progress-bar">
                  <div className="progress-fill" style={{width: `${homepageData.pageLoadSpeed}%`}}></div>
                </div>
                <span className="detail-value">{homepageData.pageLoadSpeed}%</span>
              </div>
            </div>
            <div className="score-detail-item">
              <span className="detail-label">모바일 최적화</span>
              <div className="detail-value-container">
                <div className="progress-bar">
                  <div className="progress-fill" style={{width: `${homepageData.mobileOptimization}%`}}></div>                
                </div>
                <span className="detail-value">{homepageData.mobileOptimization}%</span>
              </div>
            </div>
            <div className="score-detail-item">
              <span className="detail-label">SEO 점수</span>
              <div className="detail-value-container">
                <div className="progress-bar orange">
                  <div className="progress-fill orange" style={{width: `${homepageData.seoScore}%`}}></div>
                </div>
                <span className="detail-value">{homepageData.seoScore}%</span>
              </div>
            </div>
          </div>
        </div>

        {/* 통계 카드들 */}
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-title">
              <div className="stat-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-eye text-[#3EB034]" aria-hidden="true"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path><circle cx="12" cy="12" r="3"></circle></svg>
              </div>
              <div className="stat-title-text">
                <span className="stat-label">월 방문자</span>
              </div>
            </div>
            
            <div className="stat-content">
              <div className="stat-main">
                <span className="stat-value">{homepageData.monthlyVisitors.value}</span>
                <span className="stat-change positive">{homepageData.monthlyVisitors.change}</span>
              </div>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-title">
              <div className="stat-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="#3EB034" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12,6 12,12 16,14"/>
                </svg>
              </div>
              <div className="stat-title-text">
                <span className="stat-label">평균 체류시간</span>
              </div>
            </div>
            
            <div className="stat-content">
              <div className="stat-main">
                <span className="stat-value">{homepageData.avgStayTime.value}</span>
                <span className="stat-change positive">{homepageData.avgStayTime.change}</span>
              </div>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-title">
              <div className="stat-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trending-up text-[#3EB034]" aria-hidden="true"><path d="M16 7h6v6"></path><path d="m22 7-8.5 8.5-5-5L2 17"></path></svg>
              </div>
              <div className="stat-title-text">
                <span className="stat-label">페이지뷰</span>
              </div>
            </div>
            
            <div className="stat-content">
              <div className="stat-main">
                <span className="stat-value">{homepageData.pageViews.value}</span>
                <span className="stat-change positive">{homepageData.pageViews.change}</span>
              </div>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-title">
              <div className="stat-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-globe text-[#3EB034]" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path><path d="M2 12h20"></path></svg>
              </div>
              <div className="stat-title-text">
                <span className="stat-label">이탈률</span>
              </div>
            </div>
            
            <div className="stat-content">
              <div className="stat-main">
                <span className="stat-value">{homepageData.bounceRate.value}</span>
                <span className="stat-change negative">{homepageData.bounceRate.change}</span>
              </div>
            </div>
          </div>
        </div>

        {/* 개선 권장사항 */}
        <div className="improvements-section">
          <h3 className="improvements-title">개선 권장사항</h3>
          <div className="improvements-list">
            {homepageData.improvements.map((item, index) => (
              <div key={index} className={`improvement-item ${item.status}`}>
                <div className="improvement-bullet"></div>
                <div className="improvement-content">
                  <span className="improvement-text">{item.text}</span>
                  <p className="improvement-desc">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const renderPlaceRankingDetail = () => {
    const { placeRankingData, placeRank } = marketingData;
    // 데이터가 없을 때 안전장치
    if (!placeRankingData || !placeRank) {
      return (
        <div className="place-ranking-detail">
          <div className="detail-header">
            <button className="back-button" onClick={() => setSelectedSection(null)}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="m15 18-6-6 6-6"/>
              </svg>
              내 플레이스 순위
            </button>
            <img src={logoUrl} alt="logo" />
          </div>
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>데이터를 불러오는 중...</p>
          </div>
        </div>
      );
    }
    
    return (
      <div className="place-ranking-detail">
        {/* 헤더 */}
        <div className="detail-header">
          <button className="back-button" onClick={() => setSelectedSection(null)}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="m15 18-6-6 6-6"/>
            </svg>
            내 플레이스 순위
          </button>
          <img src={logoUrl} alt="logo" />
        </div>

        {/* 현재 순위 섹션 */}
        <div className="current-ranking-section">
          <div className="ranking-header">
            <div className="ranking-icon">
              <svg viewBox="0 0 22 22" fill="none" className="w-full h-full">
                <g><path d="M4.58333 11H2.75L11 2.75L19.25 11H17.4167" stroke="#3EB034" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.6"></path><path d="M4.58333 11V17.4167C4.58333 17.9029 4.77649 18.3692 5.1203 18.713C5.46412 19.0568 5.93044 19.25 6.41667 19.25H15.5833C16.0696 19.25 16.5359 19.0568 16.8797 18.713C17.2235 18.3692 17.4167 17.9029 17.4167 17.4167V11" stroke="#3EB034" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.6"></path><path d="M9.16667 11H12.8333V14.6667H9.16667V11Z" stroke="#3EB034" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.6"></path></g>
              </svg>
            </div>
            <span className="ranking-title">현재 순위</span>
          </div>
          <div className="current-rank">
            <span className="rank-number">{placeRank.summary.keyword?.length > 0 ? placeRank.summary.rank > 0 ? placeRank.summary.rank + '위' : '순위밖' : '플레이스정보 없음'}</span>
          </div>
          <div className="search-keywords">
            검색 키워드: "{placeRank.summary.keyword?.join('", "') || ''}"
          </div>
          {/* <div className="current-rank">
            <span className="rank-number">{placeRankingData.currentRank}위</span>
            <span className="rank-status">{placeRankingData.period} {placeRankingData.rankChange}</span>
            <span className="rank-change">상승</span>
          </div> 

          <div className="search-keywords">
            검색 키워드: "{placeRankingData.searchKeywords?.join('", "') || ''}"
          </div>
          */}
        </div>

        {/* 통계 카드들 */}
        {/* <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-title">
              <div className="stat-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin text-[#3EB034]" aria-hidden="true"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path><circle cx="12" cy="10" r="3"></circle></svg>
              </div>
              <span className="stat-label">월 노출수</span>
            </div>
            
            <div className="stat-content">
              <div className="stat-main">
                <span className="stat-value">{placeRankingData.monthlyExposure?.value || '0'}</span>
                <span className="stat-change">{placeRankingData.monthlyExposure?.change || ''}</span>
              </div>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-title">
              <div className="stat-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M16 7h6v6"/>
                  <path d="m22 7-8.5 8.5-5-5L2 17"/>
                </svg>
              </div>
              <span className="stat-label">클릭수</span>
            </div>
            
            <div className="stat-content">
              <div className="stat-main">
                <span className="stat-value">{placeRankingData.clickCount?.value || '0'}</span>
                <span className="stat-change">{placeRankingData.clickCount?.rate || ''}</span>
              </div>
            </div>
          </div>
        </div> */}
        {/* 키워드별 순위 */}
        {/* <div className="keyword-ranking-section">
          <h3 className="section-title">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search text-[#3EB034]" aria-hidden="true"><path d="m21 21-4.34-4.34"></path><circle cx="11" cy="11" r="8"></circle></svg>
            키워드별 순위
          </h3>
          <div className="keyword-list">
            {placeRank.rankList?.map((item, index) => (
              <div key={index} className="keyword-item">
                <span className="keyword-name">{item.keyword}</span>
                <div className="keyword-rank">
                  <span className="rank-value">{item.rank}위</span>
                  <span className={`rank-trend ${item.trend}`}>
                    {item.change}
                    {item.trend === 'up' && <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trending-up text-[#3EB034] rotate-0 transition-transform" aria-hidden="true"><path d="M16 7h6v6"></path><path d="m22 7-8.5 8.5-5-5L2 17"></path></svg>}
                    {item.trend === 'down' && <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trending-up text-red-500 rotate-180 transition-transform" aria-hidden="true"><path d="M16 7h6v6"></path><path d="m22 7-8.5 8.5-5-5L2 17"></path></svg>}
                    {item.trend === 'same' && <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trending-up text-gray-500 transition-transform" aria-hidden="true"><path d="M16 7h6v6"></path><path d="m22 7-8.5 8.5-5-5L2 17"></path></svg>}
                    
                  </span>
                </div>
              </div>
            )) || []}
          </div>
        </div>

        <div className="keyword-ranking-section">
          <h3 className="section-title">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search text-[#3EB034]" aria-hidden="true"><path d="m21 21-4.34-4.34"></path><circle cx="11" cy="11" r="8"></circle></svg>
            키워드별 순위
          </h3>
          <table id="test">
            <thead>
              <tr>
                <th>키워드</th>
                <th>최초</th>
                <th>최고</th>
                <th>현재</th>
              </tr>
            </thead>
            <tbody>
              {placeRank.rankList?.map((item, index) => (
                <tr key={index}>
                  <td>{item.keyword}</td>
                  <td>
                    <div className="keyword-rank">
                      <span className="rank-value">{item.rank == 0 ? '순위밖' : item.rank}</span>
                    </div>
                  </td>
                  <td>
                  <div className="keyword-rank">
                      <span className="rank-value">{item.rank == 0 ? '순위밖' : item.rank}</span>
                    </div>
                  </td>
                  <td>
                  <div className="keyword-rank">
                  <span className="rank-value">{item.rank == 0 ? '순위밖' : item.rank}</span>
                  <span className={`rank-trend ${item.trend}`}>
                    {item.change}
                    {item.trend === 'up' && <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trending-up text-[#3EB034] rotate-0 transition-transform" aria-hidden="true"><path d="M16 7h6v6"></path><path d="m22 7-8.5 8.5-5-5L2 17"></path></svg>}
                    {item.trend === 'down' && <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trending-up text-red-500 rotate-180 transition-transform" aria-hidden="true"><path d="M16 7h6v6"></path><path d="m22 7-8.5 8.5-5-5L2 17"></path></svg>}
                    {item.trend === 'same' && <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trending-up text-gray-500 transition-transform" aria-hidden="true"><path d="M16 7h6v6"></path><path d="m22 7-8.5 8.5-5-5L2 17"></path></svg>}
                    
                  </span>
                </div>
                  </td>
                </tr>
              )) || []}
            </tbody>
          </table>
        </div> */}

        <div className="keyword-ranking-section new-rank-table">
          <h3 className="section-title">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search text-[#3EB034]" aria-hidden="true"><path d="m21 21-4.34-4.34"></path><circle cx="11" cy="11" r="8"></circle></svg>
            키워드별 순위
          </h3>
          <div className="keyword-list">
            {placeRank.rankList?.map((item, index) => (
              <div key={index} className="keyword-items">
                <div className="keyword-name">키워드 : {item.keyword}</div>
                <div className="keyword-rank">
                  <span className="rank-value"><div className="rank-label">최초</div><div className="rank-label-value">{item.initRank == 0 ? '순위밖' : item.initRank}</div></span>
                  <span className="rank-value"><div className="rank-label">최고</div><div className="rank-label-value">{item.topRank == 0 ? '순위밖' : item.topRank}</div></span>
                  <span className="rank-value"><div className="rank-label">현재</div><div className="rank-label-value">{item.rank == 0 ? '순위밖' : item.rank}<span className={`rank-trend ${item.trend}`}>
                    {item.trend === 'up' && <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trending-up text-[#3EB034] rotate-0 transition-transform" aria-hidden="true"><path d="M16 7h6v6"></path><path d="m22 7-8.5 8.5-5-5L2 17"></path></svg>}
                    {item.trend === 'down' && <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trending-up text-red-500 rotate-180 transition-transform" aria-hidden="true"><path d="M16 7h6v6"></path><path d="m22 7-8.5 8.5-5-5L2 17"></path></svg>}
                    {item.trend === 'same' && <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trending-up text-gray-500 transition-transform" aria-hidden="true"><path d="M16 7h6v6"></path><path d="m22 7-8.5 8.5-5-5L2 17"></path></svg>}
                    {item.change}
                  </span></div></span>
                </div>
              </div>
            )) || []}
          </div>
        </div>
        {/* 공지 버튼 */}
        <div className="report-button fixed">
          <button className="report-btn">
            <span className="alert-icon"><p>공지</p></span>
            {/* <span className={expanded ? "alert-full-text" : "alert-one-line-text"}
      onClick={() => setExpanded(!expanded)}>{alertText}</span> */}
            <span className="alert-text">{noticeText}</span>
          </button>
        </div>
        {/* 키워드별 순위 */}
        {/* <div className="keyword-ranking-section">
          <h3 className="section-title">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search text-[#3EB034]" aria-hidden="true"><path d="m21 21-4.34-4.34"></path><circle cx="11" cy="11" r="8"></circle></svg>
            키워드별 순위
          </h3>
          <div className="keyword-list">
            {placeRankingData.keywordRankings?.map((item, index) => (
              <div key={index} className="keyword-item">
                <span className="keyword-name">{item.keyword}</span>
                <div className="keyword-rank">
                  <span className="rank-value">{item.rank}위</span>
                  <span className={`rank-trend ${item.trend}`}>
                    {item.change}
                    {item.trend === 'up' && <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trending-up text-[#3EB034] rotate-0 transition-transform" aria-hidden="true"><path d="M16 7h6v6"></path><path d="m22 7-8.5 8.5-5-5L2 17"></path></svg>}
                    {item.trend === 'down' && <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trending-up text-red-500 rotate-180 transition-transform" aria-hidden="true"><path d="M16 7h6v6"></path><path d="m22 7-8.5 8.5-5-5L2 17"></path></svg>}
                    {item.trend === 'same' && <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trending-up text-gray-500 transition-transform" aria-hidden="true"><path d="M16 7h6v6"></path><path d="m22 7-8.5 8.5-5-5L2 17"></path></svg>}
                    
                  </span>
                </div>
              </div>
            )) || []}
          </div>
        </div> */}

        {/* 리뷰 현황 */}
        {/* <div className="review-section">
          <h3 className="section-title">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-star text-[#3EB034]" aria-hidden="true"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
            리뷰 현황
          </h3>
          
          <div className="review-summary">
            <span className="review-score-container">
              <span className="review-score">{placeRankingData.reviewStats?.averageScore || '0'}</span>
              <div className="review-stars">
                {[1, 2, 3, 4, 5].map((star) => (
                  <span key={star} className="star">★</span>
                ))}
              </div>
            </span>
            <div className="review-count">총 {placeRankingData.reviewStats?.totalReviews || 0}개 리뷰</div>
          </div>

          <div className="review-distribution">
            {placeRankingData.reviewStats?.distribution?.map((rating) => (
              <div key={rating.star} className="rating-row">
                <span className="rating-label">{rating.star}★</span>
                <div className="rating-bar">
                  <div 
                    className="rating-fill" 
                    style={{width: `${placeRankingData.reviewStats?.totalReviews ? (rating.count / placeRankingData.reviewStats.totalReviews) * 100 : 0}%`}}
                  ></div>
                </div>
                <span className="rating-count">{rating.count}</span>
              </div>
            )) || []}
          </div>
        </div> */}
      </div>
    );
  };

  const renderKnowledgeViralDetail = () => {
    const { knowledgeViralData, knowledge } = marketingData;
    
    // 데이터가 없을 때 안전장치
    if (!knowledgeViralData || !knowledge) {
      return (
        <div className="knowledge-viral-detail">
          <div className="detail-header">
            <button className="back-button" onClick={() => setSelectedSection(null)}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="m15 18-6-6 6-6"/>
              </svg>
              지식인 바이럴
            </button>
            <img src={logoUrl} alt="logo" />
          </div>
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>데이터를 불러오는 중...</p>
          </div>
        </div>
      );
    }
    
    return (
      <>
      <MenuHeader title="지식인 바이럴" logoUrl={logoUrl} prevSection={setSelectedSection}/>
      <BaseImageMenu iconSvg={<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search text-[#3EB034]" aria-hidden="true"><path d="m21 21-4.34-4.34"></path><circle cx="11" cy="11" r="8"></circle></svg>} title="지식인 작업 내역" data={knowledge}/>
      <MenuFooter/>
      </>

    );
  };

  const renderMomCafeDetail = () => {
    const { momCafeData, momCafe } = marketingData;
    
    // 데이터가 없을 때 안전장치
    if (!momCafeData || !momCafe) {
      return (
        <div className="marketing-header">
          <button className="back-button" onClick={() => setSelectedSection(null)}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="m15 18-6-6 6-6"/>
            </svg>
            맘카페 바이럴
          </button>
          <img src={logoUrl} alt="logo" />
        </div>
      );
    }
    
    return (
      <>
        <MenuHeader title="맘카페 바이럴" logoUrl={logoUrl} prevSection={setSelectedSection}/>
        <BaseImageMenu iconSvg={<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search text-[#3EB034]" aria-hidden="true"><path d="m21 21-4.34-4.34"></path><circle cx="11" cy="11" r="8"></circle></svg>} title="맘카페 작업 내역" data={momCafe}/>
        <MenuFooter/>
      </>
    );
  };

  const renderBlogDetail = () => {
    const { blogData, blog } = marketingData;
    
    // 데이터가 없을 때 안전장치
    if (!blogData || !blog) {
      return (
        <div className="marketing-header">
          <button className="back-button" onClick={() => setSelectedSection(null)}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="m15 18-6-6 6-6"/>
            </svg>
            블로그 상위 노출
          </button>
          <img src={logoUrl} alt="logo" />
        </div>
      );
    }
    
    return (
      <>
        <MenuHeader title="블로그 상위 노출" logoUrl={logoUrl} prevSection={setSelectedSection}/>
        <BaseImageMenu iconSvg={<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search text-[#3EB034]" aria-hidden="true"><path d="m21 21-4.34-4.34"></path><circle cx="11" cy="11" r="8"></circle></svg>} title="블로그 작업 내역" data={blog}/>
        <MenuFooter/>
      </>
    );
  };

  const renderBlogReviewDetail = () => {
    const { blogReviewData, blogReview } = marketingData;
    
    // 데이터가 없을 때 안전장치
    if (!blogReviewData || !blogReview) {
      return (
        <div className="marketing-header">
          <button className="back-button" onClick={() => setSelectedSection(null)}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="m15 18-6-6 6-6"/>
            </svg>
            블로그 리뷰
          </button>
          <img src={logoUrl} alt="logo" />
        </div>
      );
    }
    
    // 별점 렌더링 함수
    const renderStars = (rating) => {
      const stars = [];
      for (let i = 1; i <= 5; i++) {
        stars.push(
          <svg 
            key={i} 
            className={`star ${i <= rating ? '' : 'empty'}`} 
            width="12" 
            height="12" 
            viewBox="0 0 24 24" 
            fill={i <= rating ? 'currentColor' : 'none'} 
            stroke="currentColor" 
            strokeWidth="2"
          >
            <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"/>
          </svg>
        );
      }
      return stars;
    };
    
    return (
      <>
        {/* 헤더 */}
        <div className="marketing-header">
          <button className="back-button" onClick={() => setSelectedSection(null)}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="m15 18-6-6 6-6"/>
            </svg>블로그 리뷰
          </button>          
          <img src={logoUrl} alt="logo" />
        </div>

        {/* 블로그 리뷰 현황 섹션 */}
        {/* <div className="blog-status-section">
          <h3 className="section-title">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="section-icon">
              <path d="M7.33333 8.25H14.6667M7.33333 11.9167H12.8333M16.5 3.66667C17.2293 3.66667 17.9288 3.9564 18.4445 4.47212C18.9603 4.98785 19.25 5.68732 19.25 6.41667V13.75C19.25 14.4793 18.9603 15.1788 18.4445 15.6945C17.9288 16.2103 17.2293 16.5 16.5 16.5H11.9167L7.33333 19.25V16.5H5.5C4.77065 16.5 4.07118 16.2103 3.55546 15.6945C3.03973 15.1788 2.75 14.4793 2.75 13.75V6.41667C2.75 5.68732 3.03973 4.98785 3.55546 4.47212C4.07118 3.9564 4.77065 3.66667 5.5 3.66667H16.5Z"/>
            </svg>
            블로그 리뷰 현황
          </h3>
          
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">{blogReviewData.publishedReviews}개</div>
              <div className="stat-label">발행된 리뷰</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{blogReviewData.averageRating}</div>
              <div className="stat-label">평균 평점</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{blogReviewData.totalViews}</div>
              <div className="stat-label">총 조회수</div>
            </div>
          </div>

          <div className="achievement-info">
            {blogReviewData.achievement}
          </div>
        </div> */}

        {/* 통계 카드 섹션 */}
        {/* <div className="stats-cards">
          <div className="stat-card">
            <div className="stat-icon-container">
              <div className="stat-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="section-icon">
                  <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"/>
                </svg>
              </div>
              <span className="stat-label">평균 평점</span>
            </div>
            <div className="stat-content">
              <span className="stat-number">{blogReviewData.avgRatingDetail?.value || '0'}</span>
              <span className="stat-description">{blogReviewData.avgRatingDetail?.description || ''}</span>
            </div>
          </div>
          
          <div className="stat-card">
            <div className="stat-icon-container">
              <div className="stat-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="section-icon">
                  <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
              </div>
              <span className="stat-label">평균 조회수</span>
            </div>
            <div className="stat-content">
              <span className="stat-number">{blogReviewData.avgViews?.value || '0'}</span>
              <span className="stat-description">{blogReviewData.avgViews?.description || ''}</span>
            </div>
          </div>
        </div> */}

        {/* 최근 리뷰 섹션 */}
        {/* <div className="recent-reviews-section">
          <h3 className="section-title">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-text text-[#3EB034]" aria-hidden="true"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg>
            최근 리뷰
          </h3>
          <div className="review-list">
            {blogReviewData.recentReviews?.map((review, index) => (
              <div key={index} className="review-item">
                <div className="review-header">
                  <div className="review-info">
                    <div className="review-title">{review.title}</div>
                    <div className="review-source">{review.source}</div>
                    <div className="review-stats">
                      <div className="review-stat views">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"/>
                          <circle cx="12" cy="12" r="3"/>
                        </svg>
                        {review.views}
                      </div>
                      <div className="review-stat likes">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-message-circle" aria-hidden="true"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"></path></svg>
                        {review.likes}
                      </div>
                      <div className="review-time">{review.timeAgo}</div>
                    </div>
                  </div>
                </div>
                <div className="review-rating-score">
                  <div className={`rating-text ${review.status === 'completed' ? 'completed' : 'processing'}`}>{review.status === 'completed' ? '완료' : '진행중'}</div>
                  <div className="rating-stars">
                    {renderStars(review.rating)}
                  </div>
                </div>
              </div>
            )) || []}
          </div>
        </div> */}
        {/* 리뷰 리스트 */}
        <div className="review-list-section">
          <h3 className="section-title">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-text text-[#3EB034]" aria-hidden="true"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg>
            리뷰 회차 정보
          </h3>
          <div className="review-list-table">
            <table>
              <thead>
                <tr>
                  <th>회차</th>
                  <th>URL</th>
                </tr>
              </thead>
              <tbody>
                {blogReview?.map((review, index) => (
                  <tr>
                    <td><span>{index + 1} 회차</span></td>
                    <td><a href={review.url} target="_blank" rel="noopener noreferrer">{review.url}</a></td>
                  </tr>
                )) || []}
              </tbody>
            </table>
          </div>
        </div>
          {/* 공지 버튼 */}
          <div className="report-button fixed">
          <button className="report-btn">
            <span className="alert-icon"><p>공지</p></span>
            <span className={expanded ? "alert-full-text" : "alert-one-line-text"}
      onClick={() => setExpanded(!expanded)}>{noticeText}</span>
          </button>
        </div>
      </>
    );
  };

  const renderInstagramDetail = () => {
    const { instagramData, instagram } = marketingData;
    
    // 데이터가 없을 때 안전장치
    if (!instagramData || !instagram) {
      return (
        <div className="marketing-header">
          <button className="back-button" onClick={() => setSelectedSection(null)}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="m15 18-6-6 6-6"/>
            </svg>
            인스타 추천탭 게시글
          </button>
          <img src={logoUrl} alt="logo" />
        </div>
      );
    }
    
    return (
      <>
        <MenuHeader title="인스타 추천탭 게시글" logoUrl={logoUrl} prevSection={setSelectedSection}/>
        <BaseImageMenu iconSvg={<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search text-[#3EB034]" aria-hidden="true"><path d="m21 21-4.34-4.34"></path><circle cx="11" cy="11" r="8"></circle></svg>} title="인스타 추천탭 게시글" data={instagram}/>
        <MenuFooter/>
      </>
    );
  };

  const renderReelsDetail = () => {
    const { reelsVideo } = marketingData;
    


    // 데이터가 없을 때 안전장치
    if (!reelsVideo) {
      return (
        <div className="marketing-header">
          <button className="back-button" onClick={() => setSelectedSection(null)}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="m15 18-6-6 6-6"/>
            </svg>
            인스타그램 릴스영상
          </button>
          <img src={logoUrl} alt="logo" />
        </div>
      );
    }
    
    return (
      <>
        {/* 헤더 */}
        <div className="marketing-header">
          <button className="back-button" onClick={() => setSelectedSection(null)}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="m15 18-6-6 6-6"/>
            </svg>
            인스타그램 릴스영상
          </button>
          <img src={logoUrl} alt="logo" />
        </div>

        {/* 홍보영상 유튜브 목록 섹션 */}
        <div className="youtube-video-list-section">
          <h3 className="section-title">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-video text-[#3EB034]" aria-hidden="true"><path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5"></path><rect x="2" y="6" width="14" height="12" rx="2"></rect></svg>
            인스타그램 릴스영상
          </h3>
          <div className="youtube-video-list">
            {reelsVideo?.map((video, index) => (
              <div key={index} className="youtube-video-item">
                <div class="youtube-video-thumbnail" onClick={() => {setShowPopup(true); setReelsVideoUrl(video.url); }}>
                  <img src={video.imageUrl} alt="인스타그램 릴스영상" />
                  <div class="youtube-video-play-button"></div>
                </div>
              </div>
            )) || []}
          </div>
          
        </div>
        <Popup show={showPopup} onClose={() => setShowPopup(false)} type="youtube" url={reelsVideoUrl}>
        </Popup>
          {/* 공지 버튼 */}
          <div className="report-button fixed">
          <button className="report-btn">
            <span className="alert-icon"><p>공지</p></span>
            <span className={expanded ? "alert-full-text" : "alert-one-line-text"}
      onClick={() => setExpanded(!expanded)}>{noticeText}</span>
          </button>
        </div>
      </>
    );
  };

  const renderVideoDetail = () => {
    const { promotionVideo } = marketingData;

    // 데이터가 없을 때 안전장치
    if (!promotionVideo) {
      return (
        <div className="marketing-header">
          <button className="back-button" onClick={() => setSelectedSection(null)}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="m15 18-6-6 6-6"/>
            </svg>
            플레이스 홍보영상
          </button>
          <img src={logoUrl} alt="logo" />
        </div>
      );
    }
    
    return (
      <>
        {/* 헤더 */}
        <div className="marketing-header">
          <button className="back-button" onClick={() => setSelectedSection(null)}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="m15 18-6-6 6-6"/>
            </svg>
            플레이스 홍보영상
          </button>
          <img src={logoUrl} alt="logo" />
        </div>

        {/* 홍보영상 현황 섹션 */}
        {/* <div className="video-status-section">
          <h3 className="section-title">
            <svg viewBox="0 0 22 22" fill="none" class="w-full h-full section-icon"><g><path d="M13.75 9.16666L17.9236 7.08033C18.0633 7.01051 18.2185 6.97755 18.3746 6.98458C18.5306 6.99161 18.6823 7.03839 18.8151 7.12049C18.948 7.20258 19.0577 7.31727 19.1338 7.45366C19.2099 7.59006 19.2499 7.74364 19.25 7.89983V14.1002C19.2499 14.2564 19.2099 14.4099 19.1338 14.5463C19.0577 14.6827 18.948 14.7974 18.8151 14.8795C18.6823 14.9616 18.5306 15.0084 18.3746 15.0154C18.2185 15.0224 18.0633 14.9895 17.9236 14.9197L13.75 12.8333V9.16666Z" stroke="#3EB034" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"></path><path d="M2.75 7.33333C2.75 6.8471 2.94315 6.38079 3.28697 6.03697C3.63079 5.69315 4.0971 5.5 4.58333 5.5H11.9167C12.4029 5.5 12.8692 5.69315 13.213 6.03697C13.5568 6.38079 13.75 6.8471 13.75 7.33333V14.6667C13.75 15.1529 13.5568 15.6192 13.213 15.963C12.8692 16.3068 12.4029 16.5 11.9167 16.5H4.58333C4.0971 16.5 3.63079 16.3068 3.28697 15.963C2.94315 15.6192 2.75 15.1529 2.75 14.6667V7.33333Z" stroke="#3EB034" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"></path></g></svg>
            홍보영상 현황
          </h3>
          
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">{videoData.completedVideos}개</div>
              <div className="stat-label">제작된 영상</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{videoData.totalViews}</div>
              <div className="stat-label">총 재생수</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{videoData.avgWatchTime}</div>
              <div className="stat-label">평균 시청시간</div>
            </div>
          </div>

          <div className="achievement-info">
            {videoData.achievement}
          </div>
        </div> */}

        {/* 통계 카드 섹션 */}
        {/* <div className="stats-cards">
          <div className="stat-card">
            <div className="stat-icon-container">
              <div className="stat-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-play text-[#3EB034]" aria-hidden="true"><polygon points="6 3 20 12 6 21 6 3"></polygon></svg>
              </div>
              <span className="stat-label">평균 완주율</span>
            </div>
            <div className="stat-content">
              <span className="stat-number">{videoData.avgEngagement?.value || '0'}</span>
              <span className="stat-description">{videoData.avgEngagement?.description || ''}</span>
            </div>
          </div>
          
          <div className="stat-card">
            <div className="stat-icon-container">
              <div className="stat-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-share2 lucide-share-2 text-[#3EB034]" aria-hidden="true"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" x2="15.42" y1="13.51" y2="17.49"></line><line x1="15.41" x2="8.59" y1="6.51" y2="10.49"></line></svg>
              </div>
              <span className="stat-label">공유율</span>
            </div>
            <div className="stat-content">
              <span className="stat-number">{videoData.subscriptionRate?.value || '0'}</span>
              <span className="stat-description">{videoData.subscriptionRate?.description || ''}</span>
            </div>
          </div>
        </div> */}

        {/* 홍보영상 목록 섹션 */}
        {/* <div className="video-list-section">
          <h3 className="section-title">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-video text-[#3EB034]" aria-hidden="true"><path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5"></path><rect x="2" y="6" width="14" height="12" rx="2"></rect></svg>
            홍보영상 목록
          </h3>
          <div className="video-list">
            {videoData.videoList?.map((video, index) => (
              <div key={index} className="video-item">
                <div className="video-header">
                  <div className="play-button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-play text-[#3EB034]" aria-hidden="true"><polygon points="6 3 20 12 6 21 6 3"></polygon></svg>
                  </div>
                </div>
                <div className="video-info">
                  <div className="video-title">
                    <div className="video-title-text">{video.title}</div>
                    <div className={`video-title-status ${video.status === 'active' ? 'active' : video.status === 'parse' ? 'parse' : 'stop'}`}>{video.statusText}</div>
                  </div>
                  <div className="video-platform">{video.platform} · {video.duration}</div>
                  <div className="video-stats">
                    <div className="video-stat views">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"/>
                        <circle cx="12" cy="12" r="3"/>
                      </svg>
                      {video.views}
                    </div>
                    <div className="video-stat-divider">
                      <div className="video-stat likes">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-share2 lucide-share-2" aria-hidden="true"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" x2="15.42" y1="13.51" y2="17.49"></line><line x1="15.41" x2="8.59" y1="6.51" y2="10.49"></line></svg>
                        {video.likes}
                      </div>
                      <div className="video-stat engagement-rate">
                        완주율 {video.engagementRate}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )) || []}
          </div>
        </div> */}

        {/* 홍보영상 유튜브 목록 섹션 */}
        <div className="youtube-video-list-section">
          <h3 className="section-title">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-video text-[#3EB034]" aria-hidden="true"><path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5"></path><rect x="2" y="6" width="14" height="12" rx="2"></rect></svg>
            플레이스 홍보영상
          </h3>
          <div className="youtube-video-list">
            {promotionVideo?.map((video, index) => (
              <div key={index} className="youtube-video-item">
                <div class="youtube-video-thumbnail" onClick={() => {setShowPopup(true); setVideoUrl(video.url); }}>
                  <img src={video.imageUrl} alt="홍보영상" />
                  <div class="youtube-video-play-button"></div>
                </div>
              </div>
            )) || []}
          </div>
          
        </div>
        <Popup show={showPopup} onClose={() => setShowPopup(false)} type="youtube" url={videoUrl}>
        </Popup>
  {/* 공지 버튼 */}
  <div className="report-button fixed">
          <button className="report-btn">
            <span className="alert-icon"><p>공지</p></span>
            <span className={expanded ? "alert-full-text" : "alert-one-line-text"}
      onClick={() => setExpanded(!expanded)}>{noticeText}</span>
          </button>
        </div>
        {/* 플랫폼별 분포 섹션 */}
        {/* <div className="platform-distribution-section">
          <h3 className="section-title">플랫폼별 분포</h3>
          <div className="platform-list">
            {videoData.platformDistribution?.map((platform, index) => (
              <div key={index} className="platform-item">
                <div className="platform-info">
                  <div className="platform-name">{platform.platform}</div>
                  <div className="platform-details">{platform.videoCount}개 영상 · {platform.totalViews} 조회</div>
                </div>
                <div className="platform-performance">
                  <div className="performance-bar">
                    <div 
                      className="performance-fill" 
                      style={{width: `${platform.percentage}%`}}
                    ></div>
                  </div>
                  <div className="performance-percentage">{platform.percentage}%</div>
                </div>
              </div>
            )) || []}
          </div>
        </div> */}
      </>
    );
  };

  const renderImageSection = ({title, section, convertFunc}) => {
    return (
      <>
        <MenuHeader title={title} logoUrl={logoUrl} prevSection={setSelectedSection}/>
        <BaseImageMenu iconSvg={<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search text-[#3EB034]" aria-hidden="true"><path d="m21 21-4.34-4.34"></path><circle cx="11" cy="11" r="8"></circle></svg>} title={title + " 작업 내역"} data={section} convertFunc={convertFunc}/>
        <MenuFooter/>
      </>
    );
  };

  const renderReviewSection = ({title, section, convertFunc}) => {
    return (
      <>
        <MenuHeader title={title} logoUrl={logoUrl} prevSection={setSelectedSection}/>
        <BaseReviewMenu iconSvg={<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search text-[#3EB034]" aria-hidden="true"><path d="m21 21-4.34-4.34"></path><circle cx="11" cy="11" r="8"></circle></svg>} title={title} data={section} convertFunc={convertFunc}/>
        <MenuFooter/>
      </>
    );
  };

  const renderVideoSection = ({title, section, convertFunc}) => {
    return (
      <>
        <MenuHeader title={title} logoUrl={logoUrl} prevSection={setSelectedSection}/>
        <BaseVideoMenu iconSvg={<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search text-[#3EB034]" aria-hidden="true"><path d="m21 21-4.34-4.34"></path><circle cx="11" cy="11" r="8"></circle></svg>} title={title} data={section} convertFunc={convertFunc}/>
        <MenuFooter/>
      </>
    );
  };

  if (selectedSection === 'image') {
    return (
      <div className="marketing-page base-list-image-page">
        <div className="marketing-container">
          {cssLoaded ? renderImageSection({title:menuTitle, section:sectionItem, convertFunc:convertNewType}) : (
            <div className="loading-spinner">
              <div className="spinner"></div>
              <p>페이지를 로딩 중입니다...</p>
            </div>
          )}
        </div>
      </div>
    );
  }

  if (selectedSection === 'review') {
    return (
      <div className="marketing-page base-list-review-page">
        <div className="marketing-container">
          {cssLoaded ? renderReviewSection({title:menuTitle, section:sectionItem, convertFunc:convertNewType}) : (
            <div className="loading-spinner">
              <div className="spinner"></div>
              <p>페이지를 로딩 중입니다...</p>
            </div>
          )}
        </div>
      </div>
    );
  }

  if (selectedSection === 'video') {
    return (
      <div className="marketing-page base-list-video-page">
        <div className="marketing-container">
          {cssLoaded ? renderVideoSection({title:menuTitle, section:sectionItem, convertFunc:convertNewType}) : (
            <div className="loading-spinner">
              <div className="spinner"></div>
              <p>페이지를 로딩 중입니다...</p>
            </div>
          )}
        </div>
      </div>
    );
  }
  

  // 홈페이지 상세 화면이 선택되었을 때
  if (selectedSection === 'homepage') {
    return (
      <div className="marketing-page homepage-page">
        <div className="marketing-container">
          {cssLoaded ? renderHomepageDetail() : (
            <div className="loading-spinner">
              <div className="spinner"></div>
              <p>페이지를 로딩 중입니다...</p>
            </div>
          )}
        </div>
      </div>
    );
  }

  // 내 플레이스 순위 화면이 선택되었을 때
  if (selectedSection === 'place-ranking') {
    return (
      <div className="marketing-page place-ranking-page">
        <div className="marketing-container">
          {cssLoaded ? renderPlaceRankingDetail() : (
            <div className="loading-spinner">
              <div className="spinner"></div>
              <p>페이지를 로딩 중입니다...</p>
            </div>
          )}
        </div>
      </div>
    );
  }

  // 지식인 바이럴 화면이 선택되었을 때
  if (selectedSection === 'knowledge-viral') {
    return (
      <div className="marketing-page base-list-image-page">
        <div className="marketing-container">
          {cssLoaded ? renderKnowledgeViralDetail() : (
            <div className="loading-spinner">
              <div className="spinner"></div>
              <p>페이지를 로딩 중입니다...</p>
            </div>
          )}
        </div>
      </div>
    );
  }

  // 맘카페 바이럴 화면이 선택되었을 때
  if (selectedSection === 'mom-cafe') {
    return (
      <div className="marketing-page base-list-image-page">
        <div className="marketing-container">
          {cssLoaded ? renderMomCafeDetail() : (
            <div className="loading-spinner">
              <div className="spinner"></div>
              <p>페이지를 로딩 중입니다...</p>
            </div>
          )}
        </div>
      </div>
    );
  }

  // 블로그 화면이 선택되었을 때
  if (selectedSection === 'blog') {
    return (
      <div className="marketing-page base-list-image-page">
        <div className="marketing-container">
          {cssLoaded ? renderBlogDetail() : (
            <div className="loading-spinner">
              <div className="spinner"></div>
              <p>페이지를 로딩 중입니다...</p>
            </div>
          )}
        </div>
      </div>
    );
  }

  // 블로그 리뷰 화면이 선택되었을 때
  if (selectedSection === 'blog-review') {
    return (
      <div className="marketing-page blog-review-page">
        <div className="marketing-container">
          {cssLoaded ? renderBlogReviewDetail() : (
            <div className="loading-spinner">
              <div className="spinner"></div>
              <p>페이지를 로딩 중입니다...</p>
            </div>
          )}
        </div>
      </div>
    );
  }

  // 인스타그램 화면이 선택되었을 때
  if (selectedSection === 'instagram') {
    return (
      <div className="marketing-page base-list-image-page">
        <div className="marketing-container">
          {cssLoaded ? renderInstagramDetail() : (
            <div className="loading-spinner">
              <div className="spinner"></div>
              <p>페이지를 로딩 중입니다...</p>
            </div>
          )}
        </div>
      </div>
    );
  }

  // 릴스 화면이 선택되었을 때
  if (selectedSection === 'reels') {
    return (
      <div className="marketing-page reels-page">
        <div className="marketing-container">
          {cssLoaded ? renderReelsDetail() : (
            <div className="loading-spinner">
              <div className="spinner"></div>
              <p>페이지를 로딩 중입니다...</p>
            </div>
          )}
        </div>
      </div>
    );
  }
  // 비디오 화면이 선택되었을 때
  if (selectedSection === 'video') {
    return (
      <div className="marketing-page video-page">
        <div className="marketing-container">
          {cssLoaded ? renderVideoDetail() : (
            <div className="loading-spinner">
              <div className="spinner"></div>
              <p>페이지를 로딩 중입니다...</p>
            </div>
          )}
        </div>
      </div>
    );
  }

  

  return (
    <div className="marketing-page">
      <div className="marketing-container">
                {/* 헤더 섹션 */}
        <div className="marketing-header">
          <div className="header-logo">
            <div className="header-logo-img">
              <img src={logoUrl} alt="logo" />
            </div>
            <button className="notification-button" onClick={handleNotificationClick}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/>
                <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/>
              </svg>
            </button>
          </div>
          <div className="header-top">
            <h1>{marketingData.companyName}</h1>
          </div>

          <div className="period-tag">
            <span className="period-tag-label">서비스 기간</span><span className="period-tag-value">{marketingData.period}</span>
          </div>
        </div>

        

        {/* 공지 버튼 */}
        <div className="report-button">
          <button className="report-btn">
            <span className="alert-icon">공지</span>
            <span className="alert-text">{noticeText}</span>
          </button>
        </div>

        {/* 메뉴 리스트 */}
        <div className="menu-list">
          {menuItems.map((item, index) => (
            item.isVisible && (
            <div key={index} className="menu-item" onClick={() => handleMenuClick(item.id)}>
              <span className="menu-icon">{item.icon}</span>
              <div className="menu-content">
                <div className="menu-label-box">
                  <span className="menu-label">{item.label}</span>
                  <span className="menu-sub-label">{item.description}</span>
                </div>
                <div className="menu-meta">
                {marketingData.data != null && marketingData.data.length > 0 && marketingData.typeData[camelCase(item.id)] != null && marketingData.typeData[camelCase(item.id)].length > 0 && <span className="menu-count">{marketingData.typeData[camelCase(item.id)].length}</span>}
                {marketingData.data != null && marketingData.data.length > 0 && marketingData.typeData[camelCase(item.id)] != null && marketingData.typeData[camelCase(item.id)].length > 0 && marketingData.typeData[camelCase(item.id)].some(el => el.isNew === "Y") && <span className="menu-new-icon">NEW</span>}
                </div>
              </div>
            </div>
            )
          ))}
        </div>
      </div>
      
      {/* 히스토리 페이지 */}
      {showHistory && (
        <History onClose={handleCloseHistory} idx={idx} goMenu={handleGoMenu} />
      )}
    </div>
  );
};

export default MarketingInfo; 